<template>
  <div class="payment-view">
    <navbar class="mb-5"/>
    <progress
        v-if="AppStoreStore.loading"
        class="progress is-primary is-small mt-6"
        max="100"
    ></progress>
    <div class="columns my-6">
      <div class="column is-12">
        <div class="container">
          <div class="columns mt-3">
            <div class="column is-6">
              <p class="is-size-1 has-text-left has-text-primary dm-sans has-text-weight-bold">
                PAGAMENTO
              </p>
            </div>
          </div>
          <div class="columns" v-if="orderFormData">
            <div class="column is-12">
              <steps
                ref="paymentSteps"
                :formData="orderFormData"
              >
                <template>
                  <tab name="Registrar Cartão Para Cobranças Futuras" :selected="true">
                    <div id="form-step-1">
                      <credit-card-payment
                        :formData="orderFormData"
                        @nextTab="nextTab"
                      ></credit-card-payment>
                    </div>
                  </tab>
                </template>
              </steps>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { useAppStore } from "@/stores/AppStore"
import { mapStores } from 'pinia'
import Navbar from "@/components/Wizard/Navbar"
import Steps from '@/components/Payment/Steps/Index'
import Tab from '@/components/Wizard/Tab'
import CreditCardPayment from "@/components/Payment/Tabs/CreditCardPayment"

export default {
  name: 'payment',

  components: {
    CreditCardPayment,
    Navbar,
    Steps,
    Tab
  },

  // data() {
  //   return {
  //     orderType: 'credit_card',
  //     orderFormData: {"partner":{"showStep":true,"data":{"id":1,"name":"Febrafar","plans":[{"id":5,"name":"Anual","max_users":"Ilimitados","functionalities":"TODAS AS ATUAIS","seasonality":12,"price":"209.9","setup_price":"299.9","integration_plan_id":"68669","integration_plan_product_id":"185715","integration_setup_id":"185716","discount_percentage":40}]},"hasSum":true},"plan":{"showStep":true,"unit":"mês","data":{"id":5,"name":"Anual","max_users":"Ilimitados","functionalities":"TODAS AS ATUAIS","seasonality":12,"price":"209.9","setup_price":"299.9","integration_plan_id":"68669","integration_plan_product_id":"185715","integration_setup_id":"185716","discount_percentage":40,"messagePackets":[{"id":1,"price":"129.9","mode":2,"integration_id":"185719"},{"id":2,"price":"0.01","mode":1,"integration_id":null}],"partners":[{"id":1,"name":"Febrafar"}],"extraServicePlans":[{"id":20,"plan_id":5,"extra_service_id":13,"extraService":{"id":13,"name":"Curadoria de Disparos","price":"100","type":2,"seasonality":12,"integration_id":"186505","unit_of_measurement":"/ano"}},{"id":11,"plan_id":5,"extra_service_id":8,"extraService":{"id":8,"name":"Sincronizar contatos do telefone com PedBot","price":"100","type":3,"seasonality":0,"integration_id":"186008","unit_of_measurement":"por telefone"}},{"id":8,"plan_id":5,"extra_service_id":7,"extraService":{"id":7,"name":"Sincronizar mensagens do telefone com PedBot","price":"100","type":3,"seasonality":0,"integration_id":"186007","unit_of_measurement":"por telefone"}},{"id":3,"plan_id":5,"extra_service_id":5,"extraService":{"id":5,"name":"Chip Extra Direto","price":"50","type":1,"seasonality":12,"integration_id":"185724","unit_of_measurement":"/ano"}},{"id":14,"plan_id":5,"extra_service_id":9,"extraService":{"id":9,"name":"Aquecer chip para campanhas via Whatsapp","price":"100","type":3,"seasonality":0,"integration_id":"186009","unit_of_measurement":"por telefone"}}]},"hasSum":true},"messagePacket":{"showStep":true,"data":{"id":2,"price":"0.01","mode":1,"integration_id":null},"hasSum":false},"extraChips":{"showStep":true,"data":{"id":5,"name":"Chip Extra Direto","price":"50","type":1,"seasonality":12,"integration_id":"185724","unit_of_measurement":"/ano","extraServicePlans":[{"id":3,"plan_id":5,"extra_service_id":5}],"quantity":2},"hasSum":true,"unit":"mês"},"campaignCuration":{"showStep":true,"data":{"id":13,"name":"Curadoria de Disparos","price":"100","type":2,"seasonality":12,"integration_id":"186505","unit_of_measurement":"/ano","extraServicePlans":[{"id":20,"plan_id":5,"extra_service_id":13}]},"hasSum":true,"unit":"mês"},"extraServices":{"showStep":false,"data":[{"id":7,"name":"Sincronizar mensagens do telefone com PedBot","price":"100","type":3,"seasonality":0,"integration_id":"186007","unit_of_measurement":"por telefone","extraServicePlans":[{"id":8,"plan_id":5,"extra_service_id":7}],"quantity":1},{"id":8,"name":"Sincronizar contatos do telefone com PedBot","price":"100","type":3,"seasonality":0,"integration_id":"186008","unit_of_measurement":"por telefone","extraServicePlans":[{"id":11,"plan_id":5,"extra_service_id":8}],"quantity":1},{"id":9,"name":"Aquecer chip para campanhas via Whatsapp","price":"100","type":3,"seasonality":0,"integration_id":"186009","unit_of_measurement":"por telefone","extraServicePlans":[{"id":14,"plan_id":5,"extra_service_id":9}],"quantity":1}],"hasSum":true},"technicalManager":{"showStep":false,"data":{"name":"Daniel dos Santos Andrade","phone_number":"(14) 99770-8584"},"hasSum":false},"legalGuardian":{"showStep":false,"data":{"name":"Daniel dos Santos Andrade","rg_document":"50.657.727-2","cpf_document":"438.620.028-29","phone_number":"(14) 99770-8584","email":"daniel@pedbot.com.br"},"hasSum":false},"company":{"showStep":false,"data":{"social_reason":"Daniel novo teste da plataforma","fantasy_name":"Daniel novo teste da plataforma","cnpj_document":"31.769.846/0001-14","zipcode":"17510-190","street":"Rua Ribeirão Preto","neighbourhood":"São Paulo","city":"Marília","state":"SP","number":"460","additional_details":"bloco 6, apto 635","email":"daniel@pedbot.com.br"},"hasSum":false}}
  //   }
  // },

  methods: {
    nextTab(plusPage = 1) {
      return this.$refs.paymentSteps.nextTab(plusPage)
    },
    previousTab() {
      return this.$refs.paymentSteps.previousTab()
    }
  },

  computed: {
    ...mapStores(useAppStore),
    orderType() {
      const appStore = useAppStore()
      return appStore.orderType
    },
    orderFormData() {
      const appStore = useAppStore()
      return appStore.orderFormData
    }
  }
}
</script>

<style lang="scss">

body {
  //background-color: #0091f8;
  min-height: 100vh;
  height: auto;
}

</style>
